import type { PropsWithChildren } from 'react';

import { SkyButton } from './SkyButton';

export type SkySubmitButtonProps = PropsWithChildren<{
  disabled?: boolean;
  onClick?: () => void;
  loading?: boolean;
  /** Renders the button in its destructive (danger) variant — e.g. a remove/offboarding submit. */
  danger?: boolean;
}>;

export const SkySubmitButton = ({
  disabled = true,
  children = null,
  onClick = undefined,
  loading = false,
  danger = false,
}: SkySubmitButtonProps) => {
  return (
    <SkyButton
      loading={loading}
      htmlType="submit"
      type="primary"
      shape="round"
      size="large"
      disabled={disabled}
      onClick={onClick}
      danger={danger}
    >
      {children}
    </SkyButton>
  );
};

export default SkySubmitButton;
